/**
 * Utility for generating badge print event IDs for cross-application tracing
 */

export function generateBadgePrintEventId(): string {
  return crypto.randomUUID();
}
